import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


/**
 * From ChatGPT: The code aims to filter out any query parameters from the HTTP
 * request that are either null or empty strings, and then pass the modified
 * request forward.
 */
@Injectable({
  providedIn: 'root'
})
export class ClearInterceptorService implements HttpInterceptor {

  constructor() { }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const params = {};
    request.params.keys().forEach(value => request.params.get(value) == null || request.params.get(value) === '' ? undefined
      : params[value] = String(request.params.get(value)));
    const reqClone = request.clone({ params: new HttpParams({ fromObject: params as any }) });

    return next.handle(reqClone);
  }
}
